export default [
  { name: 'English', locale: 'en' },
  { name: 'Русский', locale: 'ru' },
  { name: 'Deutsch', locale: 'de' },
  { name: 'Español', locale: 'es' },
  { name: 'Italiano', locale: 'it' },
  { name: 'Français', locale: 'fr' },
  { name: '中國', locale: 'ch' },
  { name: 'Українська мова', locale: 'uk' },
  { name: 'العربية', locale: 'ar' },
]
